import { useEffect, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useChatQuerySocket = (queryIdentifier: string): Socket | undefined => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Queries);

  useEffect(() => {
    if (!queryIdentifier) {
      return;
    }

    const newSocket = getSocket();
    setSocket(newSocket);

    newSocket.emit('subscribe', queryIdentifier);

    return () => {
      newSocket.emit('unsubscribe', queryIdentifier);
      newSocket.disconnect();
    };
  }, [getSocket, queryIdentifier]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Queries);

  return socket;
};